import type { InventoryFormValues, InventoryLookups } from '../types/inventoryForm.types';
import { BasicInfoSection } from './form/BasicInfoSection';
import { CommercialInfoSection } from './form/CommercialInfoSection';
import { TechnicalSpecSection } from './form/TechnicalSpecSection';
import { StockPricingSection } from './form/StockPricingSection';

interface InventoryFormProps {
    values: InventoryFormValues;
    stockValue: number;
    lookups?: InventoryLookups;
    onChange: <K extends keyof InventoryFormValues>(key: K, value: InventoryFormValues[K]) => void;
    isEdit?: boolean;
}

export function InventoryForm({ values, stockValue, lookups, onChange, isEdit }: InventoryFormProps) {
    return (
        <div className="space-y-4">
            <BasicInfoSection 
                values={values} 
                lookups={lookups} 
                onChange={onChange} 
                isEdit={isEdit} 
            />
            
            <CommercialInfoSection 
                values={values} 
                lookups={lookups} 
                onChange={onChange} 
            />
            
            <TechnicalSpecSection 
                values={values} 
                onChange={onChange} 
            />
            
            <StockPricingSection 
                values={values} 
                stockValue={stockValue} 
                lookups={lookups} 
                onChange={onChange} 
                isEdit={isEdit} 
            />
        </div>
    );
}
